export default __webpack_public_path__ + "static/media/i161vp.fe01dbea.webp";